(function (window, document) {
  'use strict';

  var apiName = 't4sScrollOverflow';
  var containerSelector = '[data-scroll-overflow]';

  if (window[apiName]) {
    window[apiName].init(document);
    return;
  }

  // 控制drag拖动，防止误触等
  function initDragScroll(track, callbacks) {
    var dragThreshold = 5;
    var isPointerDown = false;
    var isDragging = false;
    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var suppressClick = false;
    var clickResetId = 0;
    var isScrollable = false;
    // 记录初始化状态
    var originalCursor = track.style.cursor;
    var originalUserSelect = track.style.userSelect;
    var originalWebkitUserSelect = track.style.webkitUserSelect;
    var originalScrollSnapType = track.style.scrollSnapType;
    var onDragStart = callbacks && callbacks.onDragStart;
    var onDragEnd = callbacks && callbacks.onDragEnd;

    function setScrollable(value) {
      isScrollable = value;

      if (!isPointerDown) {
        track.style.cursor = isScrollable ? 'grab' : originalCursor;
      }
    }

    function beginDrag(clientX, id) {
      if (!isScrollable) return;

      if (clickResetId) {
        window.clearTimeout(clickResetId);
        clickResetId = 0;
      }

      suppressClick = false;
      isPointerDown = true;
      isDragging = false;
      pointerId = id;
      startX = clientX;
      startScrollLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.userSelect = 'none';
      track.style.webkitUserSelect = 'none';

      if (onDragStart) onDragStart();
    }

    function moveDrag(clientX, event) {
      if (!isPointerDown) return;

      var distance = clientX - startX;

      if (!isDragging && Math.abs(distance) < dragThreshold) return;

      if (!isDragging) {
        isDragging = true;
        track.style.scrollSnapType = 'none';

        if (
          pointerId !== null &&
          track.setPointerCapture &&
          !track.hasPointerCapture(pointerId)
        ) {
          track.setPointerCapture(pointerId);
        }
      }

      track.scrollLeft = startScrollLeft - distance;

      if (event.cancelable) {
        event.preventDefault();
      }
    }

    function endDrag() {
      if (!isPointerDown) return;

      var endedPointerId = pointerId;
      var didDrag = isDragging;

      isPointerDown = false;
      isDragging = false;
      pointerId = null;
      track.style.cursor = isScrollable ? 'grab' : originalCursor;
      track.style.userSelect = originalUserSelect;
      track.style.webkitUserSelect = originalWebkitUserSelect;
      // 拖拽完后重置状态
      track.style.scrollSnapType = originalScrollSnapType;

      if (onDragEnd) onDragEnd();

      if (
        endedPointerId !== null &&
        track.releasePointerCapture &&
        track.hasPointerCapture(endedPointerId)
      ) {
        track.releasePointerCapture(endedPointerId);
      }

      if (didDrag) {
        suppressClick = true;
        clickResetId = window.setTimeout(function () {
          suppressClick = false;
          clickResetId = 0;
        }, 0);
      }
    }

    function onPointerDown(event) {
      if (
        event.button !== 0 ||
        event.isPrimary === false ||
        event.pointerType === 'touch'
      ) {
        return;
      }

      beginDrag(event.clientX, event.pointerId);
    }

    function onPointerMove(event) {
      if (!isPointerDown || event.pointerId !== pointerId) return;
      moveDrag(event.clientX, event);
    }

    function onPointerEnd(event) {
      if (!isPointerDown || event.pointerId !== pointerId) return;
      endDrag();
    }

    function onMouseDown(event) {
      if (event.button !== 0) return;
      beginDrag(event.clientX, 'mouse');
    }

    function onMouseMove(event) {
      if (!isPointerDown) return;
      moveDrag(event.clientX, event);
    }

    track.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      },
      true
    );

    track.addEventListener('dragstart', function (event) {
      if (isPointerDown) event.preventDefault();
    });

    if ('PointerEvent' in window) {
      track.addEventListener('pointerdown', onPointerDown);
      window.addEventListener('pointermove', onPointerMove, { passive: false });
      window.addEventListener('pointerup', onPointerEnd);
      window.addEventListener('pointercancel', onPointerEnd);
      track.addEventListener('lostpointercapture', endDrag);
      document.addEventListener('pointerleave', onPointerEnd);
    } else {
      track.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove, { passive: false });
      window.addEventListener('mouseup', endDrag);
      document.addEventListener('mouseleave', endDrag);
    }

    window.addEventListener('blur', endDrag);

    return { setScrollable: setScrollable };
  }

  function initAutoScroll(container, track) {
    var focusableSelector =
      'a, button, input, select, textarea, [tabindex], [contenteditable]';
    var speed = parseFloat(container.dataset.scrollOverflowSpeed);
    var loopWidth = 0;
    var lastTimestamp = 0;
    var touchResumeId = 0;
    var isHovered = false;
    var isFocused = false;
    var isDragging = false;
    var isTouching = false;
    var isVisible = true;
    var reducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    if (!isFinite(speed) || speed <= 0) speed = 50;

    function removeDuplicateIds(clone) {
      if (clone.id) clone.removeAttribute('id');

      clone.querySelectorAll('[id]').forEach(function (element) {
        element.removeAttribute('id');
      });
    }

    function prepareClone(item) {
      var clone = item.cloneNode(true);

      clone.dataset.scrollOverflowClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      removeDuplicateIds(clone);

      if (clone.matches(focusableSelector)) {
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('contenteditable');
      }

      clone.querySelectorAll(focusableSelector).forEach(function (element) {
        element.setAttribute('tabindex', '-1');
        element.removeAttribute('contenteditable');
      });

      clone
        .querySelectorAll('[data-shopify-editor-block]')
        .forEach(function (element) {
          element.removeAttribute('data-shopify-editor-block');
        });

      return clone;
    }

    function appendCloneSet(items) {
      var fragment = document.createDocumentFragment();

      items.forEach(function (item) {
        fragment.appendChild(prepareClone(item));
      });

      track.appendChild(fragment);
    }

    function removeClones() {
      track
        .querySelectorAll('[data-scroll-overflow-clone]')
        .forEach(function (clone) {
          clone.remove();
        });
    }

    function normalizePosition() {
      if (loopWidth <= 0) return;

      if (track.scrollLeft >= loopWidth || track.scrollLeft < 0) {
        track.scrollLeft =
          ((track.scrollLeft % loopWidth) + loopWidth) % loopWidth;
      }
    }

    function refresh() {
      var previousPosition = loopWidth
        ? ((track.scrollLeft % loopWidth) + loopWidth) % loopWidth
        : track.scrollLeft;

      removeClones();

      var items = Array.prototype.filter.call(track.children, function (item) {
        return item.dataset.scrollOverflowClone !== 'true';
      });

      loopWidth = 0;
      lastTimestamp = 0;

      if (!items.length) return;

      appendCloneSet(items);

      var firstClone = track.querySelector('[data-scroll-overflow-clone]');
      loopWidth =
        firstClone.getBoundingClientRect().left -
        items[0].getBoundingClientRect().left;

      if (loopWidth <= 0) {
        removeClones();
        return;
      }

      var missingWidth = track.clientWidth + loopWidth - track.scrollWidth;
      var extraSets = Math.max(0, Math.ceil(missingWidth / loopWidth));

      while (extraSets > 0) {
        appendCloneSet(items);
        extraSets -= 1;
      }

      track.scrollLeft = previousPosition % loopWidth;
    }

    function isPaused() {
      return (
        isHovered ||
        isFocused ||
        isDragging ||
        isTouching ||
        !isVisible ||
        document.hidden ||
        (reducedMotion && reducedMotion.matches)
      );
    }

    function animate(timestamp) {
      if (!container.isConnected) return;

      if (!isPaused() && loopWidth > 0) {
        var elapsed = lastTimestamp
          ? Math.min(timestamp - lastTimestamp, 100)
          : 0;

        track.scrollLeft += (speed * elapsed) / 1000;
        normalizePosition();
      }

      lastTimestamp = timestamp;
      window.requestAnimationFrame(animate);
    }

    track.addEventListener('mouseenter', function () {
      isHovered = true;
    });

    track.addEventListener('mouseleave', function () {
      isHovered = false;
      lastTimestamp = 0;
    });

    track.addEventListener('focusin', function () {
      isFocused = true;
    });

    track.addEventListener('focusout', function (event) {
      isFocused = !!(
        event.relatedTarget && track.contains(event.relatedTarget)
      );
      lastTimestamp = 0;
    });

    track.addEventListener(
      'touchstart',
      function () {
        if (touchResumeId) window.clearTimeout(touchResumeId);
        isTouching = true;
      },
      { passive: true }
    );

    function resumeAfterTouch() {
      if (touchResumeId) window.clearTimeout(touchResumeId);

      touchResumeId = window.setTimeout(function () {
        isTouching = false;
        normalizePosition();
        lastTimestamp = 0;
        touchResumeId = 0;
      }, 800);
    }

    track.addEventListener('touchend', resumeAfterTouch, { passive: true });
    track.addEventListener('touchcancel', resumeAfterTouch, { passive: true });

    if ('IntersectionObserver' in window) {
      var intersectionObserver = new IntersectionObserver(function (entries) {
        isVisible = entries[0].isIntersecting;
        lastTimestamp = 0;
      });

      intersectionObserver.observe(container);
    }

    window.requestAnimationFrame(animate);

    return {
      refresh: refresh,
      setDragging: function (value) {
        isDragging = value;
        lastTimestamp = 0;

        if (!value) normalizePosition();
      }
    };
  }

  // 监听滚动条展示
  function initContainer(container) {
    if (!container || container.dataset.scrollOverflowReady === 'true') return;

    var track = container.querySelector('[data-scroll-overflow-track]');
    var indicator = container.querySelector('[data-scroll-overflow-indicator]');

    if (!track || !indicator) return;

    container.dataset.scrollOverflowReady = 'true';

    var frameId = 0;
    var needsAutoScrollRefresh =
      container.dataset.scrollOverflowAuto === 'true';
    var autoScroll = needsAutoScrollRefresh
      ? initAutoScroll(container, track)
      : null;
    var dragScroll = initDragScroll(track, {
      onDragStart: function () {
        if (autoScroll) autoScroll.setDragging(true);
      },
      onDragEnd: function () {
        if (autoScroll) autoScroll.setDragging(false);
      }
    });

    function update() {
      frameId = 0;

      if (autoScroll && needsAutoScrollRefresh) {
        autoScroll.refresh();
        needsAutoScrollRefresh = false;
      }

      var isScrollable = track.scrollWidth > track.clientWidth + 1;
      indicator.hidden = !!autoScroll || !isScrollable;
      dragScroll.setScrollable(isScrollable);
    }

    function requestUpdate(refreshAutoScroll) {
      if (refreshAutoScroll && autoScroll) {
        needsAutoScrollRefresh = true;
      }

      if (frameId) return;
      frameId = window.requestAnimationFrame(update);
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(function () {
        requestUpdate(!!autoScroll);
      });
      resizeObserver.observe(track);
    } else {
      window.addEventListener(
        'resize',
        function () {
          requestUpdate(!!autoScroll);
        },
        { passive: true }
      );
    }

    if ('MutationObserver' in window) {
      var mutationObserver = new MutationObserver(function (records) {
        var hasOriginalTrackChange = records.some(function (record) {
          if (record.target !== track) return false;

          return [record.addedNodes, record.removedNodes].some(
            function (nodes) {
              return Array.prototype.some.call(nodes, function (node) {
                return !(
                  node.nodeType === 1 &&
                  node.dataset.scrollOverflowClone === 'true'
                );
              });
            }
          );
        });

        if (!autoScroll || hasOriginalTrackChange) {
          requestUpdate(hasOriginalTrackChange);
        }
      });
      mutationObserver.observe(track, { childList: true, subtree: true });
    }

    update();
  }

  function init(root) {
    var scope = root || document;

    if (scope.matches && scope.matches(containerSelector)) {
      initContainer(scope);
    }

    scope.querySelectorAll(containerSelector).forEach(initContainer);
  }

  window[apiName] = { init: init };
  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})(window, document);
